import React from 'react';
export function NewsSection() {
  const news = [{
    image: 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=400',
    title: 'Novo Porto de Águas Profundas',
    date: '15 de Novembro, 2024',
    excerpt: 'Projeto de expansão portuária avança para nova fase'
  }, {
    image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=400',
    title: 'Conferência sobre Sustentabilidade',
    date: '12 de Novembro, 2024',
    excerpt: 'Especialistas debatem futuro dos oceanos'
  }, {
    image: 'https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55?w=400',
    title: 'Transporte Marítimo Cresce',
    date: '10 de Novembro, 2024',
    excerpt: 'Setor regista aumento de 15% no último trimestre'
  }, {
    image: 'https://images.unsplash.com/photo-1578575437130-527eed3abbec?w=400',
    title: 'Nova Rota Comercial',
    date: '8 de Novembro, 2024',
    excerpt: 'Ligação direta entre portos nacionais e asiáticos'
  }];
  return <div className="max-w-7xl mx-auto px-4 py-12" data-id="element-185">
      <div className="flex justify-between items-center mb-8" data-id="element-186">
        <h2 className="text-3xl font-bold text-gray-900" data-id="element-187">Notícias</h2>
        <button className="bg-blue-900 text-white px-6 py-2 rounded font-semibold" data-id="element-188">
          Ver todas
        </button>
      </div>
      <div className="grid md:grid-cols-4 gap-6" data-id="element-189">
        {news.map((item, index) => <div key={index} className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-190">
            <img src={item.image} alt={item.title} className="w-full h-48 object-cover" data-id="element-191" />
            <div className="p-4" data-id="element-192">
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-193">{item.title}</h3>
              <p className="text-sm text-gray-500 mb-2" data-id="element-194">{item.date}</p>
              <p className="text-sm text-gray-600" data-id="element-195">{item.excerpt}</p>
            </div>
          </div>)}
      </div>
    </div>;
}